import React from "react";

export default function GrouLeJeu() {
	return <div>GrouLeJeu</div>;
}
